module.exports = __webpack_public_path__ + "media/abt_vid_small.56218c18.mp4";